import { RootState } from "@/store/Store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { NormalizedApiError } from "@/helpers/apiError/NormalizedApiError";

interface ShowGlobalErrorState {
    error: NormalizedApiError | null;
}

function getInitialState(): ShowGlobalErrorState {
    return {
        error: null,
    };
}

export const ShowGlobalErrorSlice = createSlice({
    name: "ShowGlobalErrorSlice",
    initialState: getInitialState(),
    reducers: {
        setGlobalError: (state, action: PayloadAction<NormalizedApiError | null>) => {
            state.error = action.payload;
        },
    }
});

export const {
    setGlobalError,
} = ShowGlobalErrorSlice.actions;

export const globalErrorSelector = (state: RootState) => state.globalError.error;

export const ShowGlobalErrorReducer = ShowGlobalErrorSlice.reducer;